"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _draftJs = require("draft-js");

var _constants = require("draft-plugins/lib/constants");

var PUSH = _constants.replaceSelectionChangeTypes.PUSH,
    SET = _constants.replaceSelectionChangeTypes.SET;

var _default = function _default(_ref) {
  var editorState = _ref.editorState,
      text = _ref.text,
      start = _ref.start,
      end = _ref.end,
      entityKey = _ref.entityKey,
      _ref$inlineStyles = _ref.inlineStyles,
      inlineStyles = _ref$inlineStyles === void 0 ? null : _ref$inlineStyles,
      blockKey = _ref.blockKey,
      _ref$changeType = _ref.changeType,
      changeType = _ref$changeType === void 0 ? PUSH : _ref$changeType;
  var userSelection = editorState.getSelection();
  var selectedBlockKey = blockKey || userSelection.getStartKey();

  var replaceSelection = _draftJs.SelectionState.createEmpty(selectedBlockKey).merge({
    anchorOffset: start,
    focusOffset: end,
    isBackward: false,
    hasFocus: true
  });

  var contentState = _draftJs.Modifier.replaceText(editorState.getCurrentContent(), replaceSelection, text, inlineStyles, entityKey);

  var resultEditorState = editorState;

  switch (changeType) {
    case PUSH:
      resultEditorState = _draftJs.EditorState.push(editorState, contentState, 'insert-characters');
      break;

    case SET:
      resultEditorState = _draftJs.EditorState.set(editorState, {
        currentContent: contentState
      });
      break;

    default:
      resultEditorState = editorState;
      break;
  }

  var needToUpdateSelection = userSelection.getStartKey() === selectedBlockKey && userSelection.isCollapsed() && userSelection.getStartOffset() >= end;

  if (needToUpdateSelection) {
    var delta = text.length - (end - start);

    if (delta !== 0) {
      var newUserSelection = userSelection.update('anchorOffset', function (anchorOffset) {
        return anchorOffset + delta;
      }).update('focusOffset', function (focusOffset) {
        return focusOffset + delta;
      });
      resultEditorState = _draftJs.EditorState.acceptSelection(resultEditorState, newUserSelection);
    }
  }

  return resultEditorState;
};

exports.default = _default;
module.exports = exports.default;